import { SET_PROVIDER, TSetProvider } from '@r1-frontend/entities/stores/city/reducer';

export const setProviderId = (providerId: number): TSetProvider => ({
    type: SET_PROVIDER,
    payload: {
        provider: { providerId },
    },
});
